const config = {
  env: 'local',
 // apiUrl: "http://localhost:5545/admin/",
  //apiUrl: "https://api.amourtrendss.com/admin/",
  apiUrl:"https://api.cms.keyenzy.com/admin/",
  shipRocketApiUrl: "https://apiv2.shiprocket.in/v1/external/"
}

export default config;
